import _defineProperty from '@babel/runtime/helpers/defineProperty';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.reflect.to-string-tag.js';
import 'core-js/modules/es.reflect.construct.js';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import 'core-js/modules/es.date.now.js';
import 'core-js/modules/es.date.to-string.js';
import 'core-js/modules/es.array.concat.js';
import 'core-js/modules/es.number.constructor.js';
import { __decorate, __metadata } from 'tslib';
import { primary, index, field, Model, table } from '@tencent/memoire-structured-storage';

var _DOCUMENT_TYPE_MAP, _DOCUMENT_TYPE_DESC_M;
/**
 * 文档类型
 * PS: 对齐后台定义的字段，详细文件参考:
 * https://git.woa.com/docx-online/docx-online/blob/master/backend/common/proto/3rd/oidb/docs/online_docs_comm.proto
 */
var DOCUMENT_TYPE;
(function (DOCUMENT_TYPE) {
  /**
   * 兼容保留，不推荐使用，建议使用 DOCUMENT_TYPE.unknow
   */
  DOCUMENT_TYPE[DOCUMENT_TYPE["unknown"] = -1] = "unknown";
  DOCUMENT_TYPE[DOCUMENT_TYPE["doc"] = 0] = "doc";
  DOCUMENT_TYPE[DOCUMENT_TYPE["sheet"] = 1] = "sheet";
  DOCUMENT_TYPE[DOCUMENT_TYPE["form"] = 2] = "form";
  DOCUMENT_TYPE[DOCUMENT_TYPE["folder"] = 3] = "folder";
  DOCUMENT_TYPE[DOCUMENT_TYPE["slide"] = 4] = "slide";
  DOCUMENT_TYPE[DOCUMENT_TYPE["note"] = 5] = "note";
  DOCUMENT_TYPE[DOCUMENT_TYPE["pdf"] = 6] = "pdf";
  DOCUMENT_TYPE[DOCUMENT_TYPE["miniProgram"] = 7] = "miniProgram";
  DOCUMENT_TYPE[DOCUMENT_TYPE["smartCanvas"] = 8] = "smartCanvas";
  DOCUMENT_TYPE[DOCUMENT_TYPE["smartSheet"] = 9] = "smartSheet";
  DOCUMENT_TYPE[DOCUMENT_TYPE["unknow"] = 10] = "unknow";
  DOCUMENT_TYPE[DOCUMENT_TYPE["resume"] = 11] = "resume";
  DOCUMENT_TYPE[DOCUMENT_TYPE["board"] = 12] = "board";
  DOCUMENT_TYPE[DOCUMENT_TYPE["drawing"] = 89] = "drawing";
  DOCUMENT_TYPE[DOCUMENT_TYPE["mind"] = 90] = "mind";
  DOCUMENT_TYPE[DOCUMENT_TYPE["flowchart"] = 91] = "flowchart";
  DOCUMENT_TYPE[DOCUMENT_TYPE["file"] = 100] = "file";
  DOCUMENT_TYPE[DOCUMENT_TYPE["drive"] = 101] = "drive";
  DOCUMENT_TYPE[DOCUMENT_TYPE["sogoSpeech"] = 102] = "sogoSpeech";
  DOCUMENT_TYPE[DOCUMENT_TYPE["addon"] = 110] = "addon";
})(DOCUMENT_TYPE || (DOCUMENT_TYPE = {}));
/**
 * 文档类型描述
 */
var DOCUMENT_TYPE_DESC;
(function (DOCUMENT_TYPE_DESC) {
  DOCUMENT_TYPE_DESC["doc"] = "doc";
  DOCUMENT_TYPE_DESC["sheet"] = "sheet";
  DOCUMENT_TYPE_DESC["form"] = "form";
  DOCUMENT_TYPE_DESC["slide"] = "slide";
  DOCUMENT_TYPE_DESC["smartSheet"] = "smartSheet";
  DOCUMENT_TYPE_DESC["smartCanvas"] = "smartCanvas";
  DOCUMENT_TYPE_DESC["flowchart"] = "flowchart";
  DOCUMENT_TYPE_DESC["mind"] = "mind";
  DOCUMENT_TYPE_DESC["pdf"] = "pdf";
  DOCUMENT_TYPE_DESC["drive"] = "document";
})(DOCUMENT_TYPE_DESC || (DOCUMENT_TYPE_DESC = {}));
/**
 * 文档类型描述和文档类型的映射表
 */
var DOCUMENT_TYPE_MAP = (_DOCUMENT_TYPE_MAP = {}, _defineProperty(_DOCUMENT_TYPE_MAP, DOCUMENT_TYPE_DESC.doc, DOCUMENT_TYPE.doc), _defineProperty(_DOCUMENT_TYPE_MAP, DOCUMENT_TYPE_DESC.sheet, DOCUMENT_TYPE.sheet), _defineProperty(_DOCUMENT_TYPE_MAP, DOCUMENT_TYPE_DESC.slide, DOCUMENT_TYPE.slide), _defineProperty(_DOCUMENT_TYPE_MAP, DOCUMENT_TYPE_DESC.smartSheet, DOCUMENT_TYPE.smartSheet), _defineProperty(_DOCUMENT_TYPE_MAP, DOCUMENT_TYPE_DESC.smartCanvas, DOCUMENT_TYPE.smartCanvas), _defineProperty(_DOCUMENT_TYPE_MAP, DOCUMENT_TYPE_DESC.flowchart, DOCUMENT_TYPE.flowchart), _defineProperty(_DOCUMENT_TYPE_MAP, DOCUMENT_TYPE_DESC.mind, DOCUMENT_TYPE.mind), _defineProperty(_DOCUMENT_TYPE_MAP, DOCUMENT_TYPE_DESC.pdf, DOCUMENT_TYPE.pdf), _defineProperty(_DOCUMENT_TYPE_MAP, DOCUMENT_TYPE_DESC.drive, DOCUMENT_TYPE.drive), _DOCUMENT_TYPE_MAP);
/**
 * 文档类型和文档类型描述的映射表
 */
var DOCUMENT_TYPE_DESC_MAP = (_DOCUMENT_TYPE_DESC_M = {}, _defineProperty(_DOCUMENT_TYPE_DESC_M, DOCUMENT_TYPE.doc, DOCUMENT_TYPE_DESC.doc), _defineProperty(_DOCUMENT_TYPE_DESC_M, DOCUMENT_TYPE.sheet, DOCUMENT_TYPE_DESC.sheet), _defineProperty(_DOCUMENT_TYPE_DESC_M, DOCUMENT_TYPE.slide, DOCUMENT_TYPE_DESC.slide), _defineProperty(_DOCUMENT_TYPE_DESC_M, DOCUMENT_TYPE.smartSheet, DOCUMENT_TYPE_DESC.smartSheet), _defineProperty(_DOCUMENT_TYPE_DESC_M, DOCUMENT_TYPE.smartCanvas, DOCUMENT_TYPE_DESC.smartCanvas), _defineProperty(_DOCUMENT_TYPE_DESC_M, DOCUMENT_TYPE.flowchart, DOCUMENT_TYPE_DESC.flowchart), _defineProperty(_DOCUMENT_TYPE_DESC_M, DOCUMENT_TYPE.mind, DOCUMENT_TYPE_DESC.mind), _defineProperty(_DOCUMENT_TYPE_DESC_M, DOCUMENT_TYPE.pdf, DOCUMENT_TYPE_DESC.pdf), _defineProperty(_DOCUMENT_TYPE_DESC_M, DOCUMENT_TYPE.drive, DOCUMENT_TYPE_DESC.drive), _DOCUMENT_TYPE_DESC_M);
/**
 * 文档的权限策略，私有还是公开等
 */
var DOCUMENT_POLICY;
(function (DOCUMENT_POLICY) {
  DOCUMENT_POLICY[DOCUMENT_POLICY["private"] = 0] = "private";
  DOCUMENT_POLICY[DOCUMENT_POLICY["partialShare"] = 1] = "partialShare";
  DOCUMENT_POLICY[DOCUMENT_POLICY["canRead"] = 2] = "canRead";
  DOCUMENT_POLICY[DOCUMENT_POLICY["canEdit"] = 3] = "canEdit";
})(DOCUMENT_POLICY || (DOCUMENT_POLICY = {}));
/**
 * 文档的状态
 */
var DOCUMENT_STATUS;
(function (DOCUMENT_STATUS) {
  DOCUMENT_STATUS["new"] = "new";
  DOCUMENT_STATUS["local"] = "local";
  DOCUMENT_STATUS["deleted"] = "deleted";
  DOCUMENT_STATUS["normal"] = "normal";
})(DOCUMENT_STATUS || (DOCUMENT_STATUS = {}));
/**
 *  文档内资源（图片、附件等）缓存状态
 */
var DOCUMENT_RESOURCE_CACHE_STATUS;
(function (DOCUMENT_RESOURCE_CACHE_STATUS) {
  // 未知状态，甚至可能没资源
  DOCUMENT_RESOURCE_CACHE_STATUS["NONE"] = "none";
  // 缓存完成
  DOCUMENT_RESOURCE_CACHE_STATUS["SUCCESS"] = "success";
  // 因为网络原因缓存失败，可重试
  DOCUMENT_RESOURCE_CACHE_STATUS["FAIL"] = "fail";
  // 非网络原因，数据错误或者安全打击等确定异常导致缓存失败
  DOCUMENT_RESOURCE_CACHE_STATUS["ERROR"] = "error";
})(DOCUMENT_RESOURCE_CACHE_STATUS || (DOCUMENT_RESOURCE_CACHE_STATUS = {}));
/**
 * 列表页文件类型
 */
var LIST_INFO_TYPE;
(function (LIST_INFO_TYPE) {
  LIST_INFO_TYPE[LIST_INFO_TYPE["file"] = 1] = "file";
  LIST_INFO_TYPE[LIST_INFO_TYPE["folder"] = 2] = "folder";
})(LIST_INFO_TYPE || (LIST_INFO_TYPE = {}));
/**
 * 文件在列表中的分类
 */
var LIST_TYPE;
(function (LIST_TYPE) {
  LIST_TYPE[LIST_TYPE["trash"] = 3] = "trash";
  LIST_TYPE[LIST_TYPE["share"] = 4] = "share";
  LIST_TYPE[LIST_TYPE["myDoc"] = 5] = "myDoc";
  LIST_TYPE[LIST_TYPE["recent"] = 6] = "recent";
  LIST_TYPE[LIST_TYPE["start"] = 7] = "start";
})(LIST_TYPE || (LIST_TYPE = {}));
/**
 * 文档数据记录的类型
 */
var DOCUMENT_DATA_TYPE;
(function (DOCUMENT_DATA_TYPE) {
  DOCUMENT_DATA_TYPE["init"] = "init";
  DOCUMENT_DATA_TYPE["document"] = "document";
  DOCUMENT_DATA_TYPE["workbook"] = "workbook";
  DOCUMENT_DATA_TYPE["chunk"] = "chunk";
  DOCUMENT_DATA_TYPE["accepted"] = "accepted";
  DOCUMENT_DATA_TYPE["missChange"] = "misschange";
  DOCUMENT_DATA_TYPE["newChange"] = "newchange";
  DOCUMENT_DATA_TYPE["committing"] = "commiting";
  DOCUMENT_DATA_TYPE["waiting"] = "watting";
  DOCUMENT_DATA_TYPE["queue"] = "queue";
})(DOCUMENT_DATA_TYPE || (DOCUMENT_DATA_TYPE = {}));
/**
 * drive文件类型
 */
var DRIVE_TYPE;
(function (DRIVE_TYPE) {
  DRIVE_TYPE["drive"] = "drive";
  DRIVE_TYPE["attachment"] = "attachment";
})(DRIVE_TYPE || (DRIVE_TYPE = {}));

/**
 * 数据库名
 */
// 正式环境数据库名
var DB_NAME = 'TencentDocs';
// 正式环境 本地文件 数据库名
var ALL_LOCAL_FILES_DB_NAME = 'all-local-files/TencentDocs';
// 非正式环境数据库名
var DB_NAME_TESTENV = 'TencentDocs_TestEnv';
/**
 * 数据库表名
 */
var TABLE_NAME;
(function (TABLE_NAME) {
  // 文档状态表
  TABLE_NAME["documentStatus"] = "DocumentStatus";
  // 文档扩展数据表
  TABLE_NAME["documentEntities"] = "DocumentEntities";
  // 预拉取文档id表
  TABLE_NAME["newDocumentIds"] = "NewDocumentIds";
  // 文档信息表（与客户端列表页共享）
  TABLE_NAME["padinfo"] = "PadInfo";
  // 文档离线编辑的本地数据表
  TABLE_NAME["offlineData"] = "OfflineData";
  // 文档已落盘数据表
  TABLE_NAME["documentData"] = "DocumentData";
  // 用户数据表
  TABLE_NAME["Users"] = "Users";
  // drive数据表
  TABLE_NAME["driveData"] = "DriveData";
})(TABLE_NAME || (TABLE_NAME = {}));

/**
 * @deprecated 不要在这里维护账号类型，应该使用后台协议中定义的枚举值
 * import type { docx } from '@tencent/tdocs-shared-proto/lib/3rd/oidb/user/data/online_docs_user_data';
 * export type ACCOUNT_TYPE = docx.backend.common.proto.third.oidb.user.data.UID_SOURCE;
 * 登录类型
 */
var ACCOUNT_TYPE;
(function (ACCOUNT_TYPE) {
  ACCOUNT_TYPE[ACCOUNT_TYPE["UNKNOWN"] = 0] = "UNKNOWN";
  ACCOUNT_TYPE[ACCOUNT_TYPE["QQ"] = 1] = "QQ";
  ACCOUNT_TYPE[ACCOUNT_TYPE["WX"] = 2] = "WX";
  ACCOUNT_TYPE[ACCOUNT_TYPE["WORK"] = 3] = "WORK";
  ACCOUNT_TYPE[ACCOUNT_TYPE["EMAIL"] = 4] = "EMAIL";
  ACCOUNT_TYPE[ACCOUNT_TYPE["PHONE"] = 8] = "PHONE";
  ACCOUNT_TYPE[ACCOUNT_TYPE["WORK_COMBINATION"] = 9] = "WORK_COMBINATION";
  ACCOUNT_TYPE[ACCOUNT_TYPE["TOWER"] = 10] = "TOWER";
  ACCOUNT_TYPE[ACCOUNT_TYPE["ROBOT"] = 11] = "ROBOT";
  ACCOUNT_TYPE[ACCOUNT_TYPE["QFYF"] = 12] = "QFYF";
  ACCOUNT_TYPE[ACCOUNT_TYPE["OPEN"] = 13] = "OPEN";
  ACCOUNT_TYPE[ACCOUNT_TYPE["MEETING"] = 14] = "MEETING";
})(ACCOUNT_TYPE || (ACCOUNT_TYPE = {}));
// b端登录类型
var LOGINTYPE;
(function (LOGINTYPE) {
  LOGINTYPE[LOGINTYPE["UNKNOWN"] = 0] = "UNKNOWN";
  /**
   * 微信登录
   **/
  LOGINTYPE[LOGINTYPE["WECHAT"] = 4] = "WECHAT";
  /**
   * 企业微信登录
   **/
  LOGINTYPE[LOGINTYPE["WEWORK"] = 3] = "WEWORK";
})(LOGINTYPE || (LOGINTYPE = {}));

var BIND_TYPE;
(function (BIND_TYPE) {
  /**
   * 有绑定账号
   */
  BIND_TYPE["BINDING"] = "BINDING";
  /**
   * 没有绑定账号
   */
  BIND_TYPE["UNBIND"] = "UNBIND";
})(BIND_TYPE || (BIND_TYPE = {}));
var VipType;
(function (VipType) {
  /**
   * 常规vip类型
   */
  VipType["NORMAL"] = "NORMAL";
  /**
   * 超级vip类型
   */
  VipType["SUPER"] = "SUPER";
  /**
   * 超级vip plus
   */
  VipType["SUPER_PLUS"] = "SUPER_PLUS";
  /**
   * 没有vip
   */
  VipType["NONE"] = "NONE";
  /**
   * 过期的 VIP
   */
  VipType["EXPIRED"] = "EXPIRED";
})(VipType || (VipType = {}));
var VipLevel;
(function (VipLevel) {
  VipLevel[VipLevel["NORMAL"] = 2] = "NORMAL";
  VipLevel[VipLevel["SUPER"] = 3] = "SUPER";
  VipLevel[VipLevel["SUPER_PLUS"] = 4] = "SUPER_PLUS";
  VipLevel[VipLevel["NONE"] = 1] = "NONE";
  VipLevel[VipLevel["EXPIRED"] = 0] = "EXPIRED";
})(VipLevel || (VipLevel = {}));

function _createSuper$8(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$8(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$8() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var randomRange = 2147483648;
/**
 * 文档变更记录Model，目前关键帧记录和离线编辑记录Model实际上存储字段相同，抽象一个公共Model
 */
var BaseChangeModel = /*#__PURE__*/function (_Model) {
  _inherits(BaseChangeModel, _Model);
  var _super = _createSuper$8(BaseChangeModel);
  function BaseChangeModel(option) {
    var _this;
    _classCallCheck(this, BaseChangeModel);
    var _a, _b, _c, _d, _e, _f;
    _this = _super.call(this);
    // 是否是默认关键帧
    _this.isDefaultChunk = false;
    // 必填字段赋值
    _this.uid = option.uid;
    _this.type = option.type;
    _this.data = option.data;
    _this.dataVersion = option.dataVersion;
    _this.docType = option.docType;
    _this.subId = option.subId;
    _this.secretId = option.secretId;
    _this.version = option.version;
    _this.globalPadId = option.globalPadId;
    // 可选字段给默认值
    _this.taskId = (_a = option.taskId) !== null && _a !== void 0 ? _a : _this.getTaskId();
    _this.isDefaultChunk = (_b = option.isDefaultChunk) !== null && _b !== void 0 ? _b : false;
    _this.chunkId = (_c = option.chunkId) !== null && _c !== void 0 ? _c : 0;
    _this.docStatus = (_d = option.docStatus) !== null && _d !== void 0 ? _d : DOCUMENT_STATUS.normal;
    _this.createTimestamp = (_e = option.createTimestamp) !== null && _e !== void 0 ? _e : Date.now();
    _this.lastModifyTimestamp = (_f = option.lastModifyTimestamp) !== null && _f !== void 0 ? _f : Date.now();
    _this.key = _this.getKey();
    _this.subGlobalPadId = option.subGlobalPadId;
    _this.subDocType = option.subDocType;
    return _this;
  }
  _createClass(BaseChangeModel, [{
    key: "getTaskId",
    value: function getTaskId() {
      return Math.ceil(Math.random() * randomRange);
    }
  }, {
    key: "getKey",
    value: function getKey() {
      var key;
      if (this.type === DOCUMENT_DATA_TYPE.init) {
        key = "".concat(this.globalPadId, "_").concat(this.subId, "_").concat(this.uid);
      } else if (this.type === DOCUMENT_DATA_TYPE.document) {
        key = "".concat(this.globalPadId, "_").concat(this.uid, "_version_").concat(this.version);
      } else if (this.type === DOCUMENT_DATA_TYPE.workbook) {
        key = "".concat(this.globalPadId, "_").concat(this.subId, "_").concat(this.uid, "_version_").concat(this.version);
      } else if (this.type === DOCUMENT_DATA_TYPE.chunk) {
        key = "".concat(this.globalPadId, "_").concat(this.subId, "_").concat(this.chunkId, "_").concat(this.uid, "_version_").concat(this.version);
      } else {
        key = "".concat(this.globalPadId, "_").concat(this.subId, "_").concat(this.uid, "_taskId_").concat(this.taskId);
      }
      return key;
    }
  }]);
  return BaseChangeModel;
}(Model);
__decorate([primary(), __metadata("design:type", String)], BaseChangeModel.prototype, "key", void 0);
__decorate([index(), __metadata("design:type", String)], BaseChangeModel.prototype, "secretId", void 0);
__decorate([index(), __metadata("design:type", String)], BaseChangeModel.prototype, "globalPadId", void 0);
__decorate([index(), __metadata("design:type", String)], BaseChangeModel.prototype, "subGlobalPadId", void 0);
__decorate([index(), __metadata("design:type", Number)], BaseChangeModel.prototype, "subDocType", void 0);
__decorate([index(), __metadata("design:type", Number)], BaseChangeModel.prototype, "version", void 0);
__decorate([index(), __metadata("design:type", String)], BaseChangeModel.prototype, "type", void 0);
__decorate([index(), __metadata("design:type", String)], BaseChangeModel.prototype, "uid", void 0);
__decorate([index(), field('subSheetId'), __metadata("design:type", String)], BaseChangeModel.prototype, "subId", void 0);
__decorate([index(), __metadata("design:type", Number)], BaseChangeModel.prototype, "chunkId", void 0);
__decorate([field(), __metadata("design:type", Number)], BaseChangeModel.prototype, "taskId", void 0);
__decorate([field('_data'), __metadata("design:type", String)], BaseChangeModel.prototype, "data", void 0);
__decorate([field(), __metadata("design:type", Number)], BaseChangeModel.prototype, "docType", void 0);
__decorate([field('padStatus'), __metadata("design:type", String)], BaseChangeModel.prototype, "docStatus", void 0);
__decorate([field('createTime'), __metadata("design:type", Number)], BaseChangeModel.prototype, "createTimestamp", void 0);
__decorate([field()
// 最近修改时间
, __metadata("design:type", Number)], BaseChangeModel.prototype, "lastModifyTimestamp", void 0);
__decorate([field('dver'), __metadata("design:type", String)], BaseChangeModel.prototype, "dataVersion", void 0);
__decorate([field('default'), __metadata("design:type", Object)], BaseChangeModel.prototype, "isDefaultChunk", void 0);

function _createSuper$7(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$7(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$7() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DocumentData = /*#__PURE__*/function (_BaseChangeModel) {
  _inherits(DocumentData, _BaseChangeModel);
  var _super = _createSuper$7(DocumentData);
  function DocumentData() {
    _classCallCheck(this, DocumentData);
    return _super.apply(this, arguments);
  }
  return _createClass(DocumentData);
}(BaseChangeModel);
DocumentData = __decorate([table(TABLE_NAME.documentData)], DocumentData);

function _createSuper$6(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$6(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$6() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * 文档的扩展数据表
 *
 */
var DocumentEntity = /*#__PURE__*/function (_Model) {
  _inherits(DocumentEntity, _Model);
  var _super = _createSuper$6(DocumentEntity);
  function DocumentEntity() {
    _classCallCheck(this, DocumentEntity);
    return _super.apply(this, arguments);
  }
  return _createClass(DocumentEntity);
}(Model);
__decorate([primary(), __metadata("design:type", String)], DocumentEntity.prototype, "key", void 0);
__decorate([field(), __metadata("design:type", Object)], DocumentEntity.prototype, "data", void 0);
DocumentEntity = __decorate([table(TABLE_NAME.documentEntities)], DocumentEntity);

function _createSuper$5(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$5(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$5() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * 文档状态表，用于记录文档数据同步的状态
 */
var DocumentId = /*#__PURE__*/function (_Model) {
  _inherits(DocumentId, _Model);
  var _super = _createSuper$5(DocumentId);
  function DocumentId() {
    var _this;
    _classCallCheck(this, DocumentId);
    _this = _super.apply(this, arguments);
    // 文档是否已被用于创建，客户端在使用该标记位
    _this.isCreated = false;
    return _this;
  }
  return _createClass(DocumentId);
}(Model);
__decorate([primary(), __metadata("design:type", String)], DocumentId.prototype, "globalPadId", void 0);
__decorate([field(), __metadata("design:type", String)], DocumentId.prototype, "secretId", void 0);
__decorate([field(), __metadata("design:type", Number)], DocumentId.prototype, "documentType", void 0);
__decorate([field(), __metadata("design:type", String)], DocumentId.prototype, "localPadId", void 0);
__decorate([field(), __metadata("design:type", Object)], DocumentId.prototype, "isCreated", void 0);
DocumentId = __decorate([table(TABLE_NAME.newDocumentIds)], DocumentId);

function _createSuper$4(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$4(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$4() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * 文档状态表，用于记录文档数据同步的状态
 */
var DocumentStatus = /*#__PURE__*/function (_Model) {
  _inherits(DocumentStatus, _Model);
  var _super = _createSuper$4(DocumentStatus);
  function DocumentStatus() {
    var _this;
    _classCallCheck(this, DocumentStatus);
    _this = _super.apply(this, arguments);
    // 文档最新数据同步的时间
    _this.lastSyncTimestamp = 0;
    return _this;
  }
  return _createClass(DocumentStatus);
}(Model);
__decorate([primary(), __metadata("design:type", String)], DocumentStatus.prototype, "globalPadId", void 0);
__decorate([index(), __metadata("design:type", String)], DocumentStatus.prototype, "secretId", void 0);
__decorate([index(), __metadata("design:type", String)], DocumentStatus.prototype, "uid", void 0);
__decorate([field('lastSyncTime'), __metadata("design:type", Object)], DocumentStatus.prototype, "lastSyncTimestamp", void 0);
__decorate([field(), __metadata("design:type", Number)], DocumentStatus.prototype, "lastErrorTimestamp", void 0);
DocumentStatus = __decorate([table(TABLE_NAME.documentStatus)], DocumentStatus);

function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DriveData = /*#__PURE__*/function (_Model) {
  _inherits(DriveData, _Model);
  var _super = _createSuper$3(DriveData);
  function DriveData() {
    _classCallCheck(this, DriveData);
    return _super.apply(this, arguments);
  }
  return _createClass(DriveData);
}(Model);
__decorate([primary(), __metadata("design:type", String)], DriveData.prototype, "driveId", void 0);
__decorate([index(), __metadata("design:type", String)], DriveData.prototype, "fileId", void 0);
__decorate([index(), __metadata("design:type", String)], DriveData.prototype, "objKey", void 0);
__decorate([index(), __metadata("design:type", String)], DriveData.prototype, "secretId", void 0);
__decorate([index(), __metadata("design:type", String)], DriveData.prototype, "uid", void 0);
__decorate([field('type'), __metadata("design:type", String)], DriveData.prototype, "type", void 0);
__decorate([field('lastRequestTime'), __metadata("design:type", Number)], DriveData.prototype, "lastRequestTime", void 0);
__decorate([field('fileInfo'), __metadata("design:type", Object)], DriveData.prototype, "fileInfo", void 0);
__decorate([field('previewInfo'), __metadata("design:type", Object)], DriveData.prototype, "previewInfo", void 0);
DriveData = __decorate([table(TABLE_NAME.driveData)], DriveData);

function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * 文档本地离线数据表
 */
var OfflineData = /*#__PURE__*/function (_BaseChangeModel) {
  _inherits(OfflineData, _BaseChangeModel);
  var _super = _createSuper$2(OfflineData);
  function OfflineData() {
    _classCallCheck(this, OfflineData);
    return _super.apply(this, arguments);
  }
  return _createClass(OfflineData);
}(BaseChangeModel);
OfflineData = __decorate([table(TABLE_NAME.offlineData)], OfflineData);

function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * 文档信息表
 * ❌❌❌ PS：该Model中的字段对齐后台字段，大部分为使用下划线命名的参数（不符合代码规范，后续协商优化）
 */
var PadInfo = /*#__PURE__*/function (_Model) {
  _inherits(PadInfo, _Model);
  var _super = _createSuper$1(PadInfo);
  function PadInfo() {
    var _this;
    _classCallCheck(this, PadInfo);
    _this = _super.apply(this, arguments);
    _this.addListTimestamp = 0;
    _this.attribute = null;
    // 文档权限策略，默认为私有权限
    _this.docPolicy = DOCUMENT_POLICY["private"];
    _this.docPrivilege = null;
    _this.folderPolicy = 0;
    _this.folderPrivilege = null;
    // 是否手动离线
    _this.isManualOffline = false;
    // 是否离线缓存
    _this.isOfflineCache = false;
    // 是否渲染了快照
    _this.hasSnapShot = false;
    // 是否添加到我的文档
    _this.isAddedToMy = 0;
    // 是否为星标文档
    _this.isCollected = 0;
    // 当前用户是否为所有者
    _this.isOwner = 1;
    // 是否置顶
    _this.isPinned = 0;
    // 是否为快捷方式
    _this.isShortcut = 0;
    // 用户是否手动修改过标题
    _this.isUserChangeTitle = false;
    _this.lastCollectTimestamp = 0;
    _this.lastDeleteTimestamp = 0;
    _this.parents = [];
    _this.cacheStatus = 0; // CacheStatus as number
    return _this;
  }
  return _createClass(PadInfo);
}(Model);
__decorate([primary(), __metadata("design:type", String)], PadInfo.prototype, "key", void 0);
__decorate([index(), __metadata("design:type", String)], PadInfo.prototype, "secretId", void 0);
__decorate([index(), __metadata("design:type", String)], PadInfo.prototype, "globalPadId", void 0);
__decorate([index(), __metadata("design:type", String)], PadInfo.prototype, "uid", void 0);
__decorate([field('add_list_ts'), __metadata("design:type", Object)], PadInfo.prototype, "addListTimestamp", void 0);
__decorate([field(), __metadata("design:type", Object)], PadInfo.prototype, "attribute", void 0);
__decorate([field(), __metadata("design:type", Number)], PadInfo.prototype, "childrenLength", void 0);
__decorate([field('client_version'), __metadata("design:type", String)], PadInfo.prototype, "clientVersion", void 0);
__decorate([field('create_ts'), __metadata("design:type", Number)], PadInfo.prototype, "createTimestamp", void 0);
__decorate([field(), __metadata("design:type", String)], PadInfo.prototype, "creator", void 0);
__decorate([field('creator_domain'), __metadata("design:type", String)], PadInfo.prototype, "creatorDomain", void 0);
__decorate([field('doc_icon'), __metadata("design:type", String)], PadInfo.prototype, "icon", void 0);
__decorate([field('doc_policy'), __metadata("design:type", Number)], PadInfo.prototype, "docPolicy", void 0);
__decorate([field('doc_privilege'), __metadata("design:type", Object)], PadInfo.prototype, "docPrivilege", void 0);
__decorate([field('doc_thumbnail'), __metadata("design:type", String)], PadInfo.prototype, "thumbnail", void 0);
__decorate([field('doc_type'), __metadata("design:type", Number)], PadInfo.prototype, "docType", void 0);
__decorate([field('doc_type_desc'), __metadata("design:type", String)], PadInfo.prototype, "docTypeDesc", void 0);
__decorate([field('doc_url'), __metadata("design:type", String)], PadInfo.prototype, "url", void 0);
__decorate([field('domain_id'), __metadata("design:type", String)], PadInfo.prototype, "domainId", void 0);
__decorate([field(), __metadata("design:type", String)], PadInfo.prototype, "dver", void 0);
__decorate([field(), __metadata("design:type", String)], PadInfo.prototype, "folder", void 0);
__decorate([field('folder_id'), __metadata("design:type", String)], PadInfo.prototype, "folderId", void 0);
__decorate([field('folder_policy'), __metadata("design:type", Object)], PadInfo.prototype, "folderPolicy", void 0);
__decorate([field('folder_privilege'), __metadata("design:type", Object)], PadInfo.prototype, "folderPrivilege", void 0);
__decorate([field('isDelete'), __metadata("design:type", Boolean)], PadInfo.prototype, "isDeleted", void 0);
__decorate([field(), __metadata("design:type", Object)], PadInfo.prototype, "isManualOffline", void 0);
__decorate([field(), __metadata("design:type", Boolean)], PadInfo.prototype, "isMyCreated", void 0);
__decorate([field(), __metadata("design:type", Boolean)], PadInfo.prototype, "isMydoc", void 0);
__decorate([field(), __metadata("design:type", Object)], PadInfo.prototype, "isOfflineCache", void 0);
__decorate([field(), __metadata("design:type", Boolean)], PadInfo.prototype, "isRencent", void 0);
__decorate([field('isShareme'), __metadata("design:type", Boolean)], PadInfo.prototype, "isShareToMe", void 0);
__decorate([field('isSnapShot'), __metadata("design:type", Object)], PadInfo.prototype, "hasSnapShot", void 0);
__decorate([field(), __metadata("design:type", Boolean)], PadInfo.prototype, "isStar", void 0);
__decorate([field('is_added_my'), __metadata("design:type", Object)], PadInfo.prototype, "isAddedToMy", void 0);
__decorate([field('is_collected'), __metadata("design:type", Object)], PadInfo.prototype, "isCollected", void 0);
__decorate([field('is_owner'), __metadata("design:type", Object)], PadInfo.prototype, "isOwner", void 0);
__decorate([field('is_pinned'), __metadata("design:type", Object)], PadInfo.prototype, "isPinned", void 0);
__decorate([field('is_shortcut'), __metadata("design:type", Object)], PadInfo.prototype, "isShortcut", void 0);
__decorate([field(), __metadata("design:type", Object)], PadInfo.prototype, "isUserChangeTitle", void 0);
__decorate([field('lastSyncTime'), __metadata("design:type", Number)], PadInfo.prototype, "lastSyncTimestamp", void 0);
__decorate([field('last_browse_ts'), __metadata("design:type", Number)], PadInfo.prototype, "lastBrowseTimestamp", void 0);
__decorate([field('last_collect_ts'), __metadata("design:type", Object)], PadInfo.prototype, "lastCollectTimestamp", void 0);
__decorate([field('last_delete_ts'), __metadata("design:type", Object)], PadInfo.prototype, "lastDeleteTimestamp", void 0);
__decorate([field('last_modify_ts'), __metadata("design:type", Number)], PadInfo.prototype, "lastModifyTimestamp", void 0);
__decorate([field('last_modify_nick'), __metadata("design:type", String)], PadInfo.prototype, "lastModifyNick", void 0);
__decorate([field('last_modify_uid'), __metadata("design:type", String)], PadInfo.prototype, "lastModifyUid", void 0);
__decorate([field('last_pinned_ts'), __metadata("design:type", Number)], PadInfo.prototype, "lastPinnedTimestamp", void 0);
__decorate([field('list_info_type'), __metadata("design:type", Number)], PadInfo.prototype, "listInfoType", void 0);
__decorate([field('list_type'), __metadata("design:type", Number)], PadInfo.prototype, "listType", void 0);
__decorate([field(), __metadata("design:type", Boolean)], PadInfo.prototype, "offlineCommiting", void 0);
__decorate([field(), __metadata("design:type", Boolean)], PadInfo.prototype, "offlineCommitSuccessd", void 0);
__decorate([field('origin_folder_id'), __metadata("design:type", String)], PadInfo.prototype, "originFolderId", void 0);
__decorate([field('owner_nick'), __metadata("design:type", String)], PadInfo.prototype, "ownerNick", void 0);
__decorate([field('owner_uid'), __metadata("design:type", String)], PadInfo.prototype, "ownerUid", void 0);
__decorate([field('pad_id'), __metadata("design:type", String)], PadInfo.prototype, "padId", void 0);
__decorate([field('parent_folder_id'), __metadata("design:type", String)], PadInfo.prototype, "parentFolderId", void 0);
__decorate([field(), __metadata("design:type", Array)], PadInfo.prototype, "parents", void 0);
__decorate([field(), __metadata("design:type", Number)], PadInfo.prototype, "privilege", void 0);
__decorate([field(), __metadata("design:type", String)], PadInfo.prototype, "status", void 0);
__decorate([field(), __metadata("design:type", String)], PadInfo.prototype, "title", void 0);
__decorate([field(), __metadata("design:type", Number)], PadInfo.prototype, "type", void 0);
__decorate([field('uncommit'), __metadata("design:type", Boolean)], PadInfo.prototype, "hasLocalChanges", void 0);
__decorate([field('doc_sub_type'), __metadata("design:type", Number)], PadInfo.prototype, "docSubType", void 0);
__decorate([field('official_auth_info'), __metadata("design:type", String)], PadInfo.prototype, "officialAuthInfo", void 0);
__decorate([field('personalize_info'), __metadata("design:type", String)], PadInfo.prototype, "personalizeInfo", void 0);
__decorate([field('nativeEngineStatusRecord'), __metadata("design:type", String)], PadInfo.prototype, "nativeEngineStatusRecord", void 0);
__decorate([field('nativeEngineDocPrivilege'), __metadata("design:type", String)], PadInfo.prototype, "nativeEngineDocPrivilege", void 0);
__decorate([field(), __metadata("design:type", String)], PadInfo.prototype, "data", void 0);
__decorate([field(), __metadata("design:type", String)], PadInfo.prototype, "ext", void 0);
__decorate([field(), __metadata("design:type", Boolean)], PadInfo.prototype, "isOfflineCacheByNative", void 0);
__decorate([field('mime_type'), __metadata("design:type", String)], PadInfo.prototype, "mimeType", void 0);
__decorate([field('owner_vip_info'), __metadata("design:type", String)], PadInfo.prototype, "ownerVipInfo", void 0);
__decorate([field('documentResourceCacheStatus'), __metadata("design:type", String)], PadInfo.prototype, "documentResourceCacheStatus", void 0);
__decorate([field('cache_status'), __metadata("design:type", Object)], PadInfo.prototype, "cacheStatus", void 0);
__decorate([field('cache_status_ts'), __metadata("design:type", Number)], PadInfo.prototype, "cacheStatusTs", void 0);
PadInfo = __decorate([table(TABLE_NAME.padinfo)], PadInfo);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var UserInfo = /*#__PURE__*/function (_Model) {
  _inherits(UserInfo, _Model);
  var _super = _createSuper(UserInfo);
  function UserInfo(option) {
    var _this;
    _classCallCheck(this, UserInfo);
    var _a, _b, _c;
    _this = _super.call(this);
    _this.docId = option.docId;
    _this.pageType = option.pageType;
    _this.updateTime = option.updateTime;
    _this.tinyId = option.tinyId;
    _this.wedriveUin = option.wedriveUin;
    _this.wedocOpenId = option.wedocOpenId;
    _this.nowUserIndex = (_a = option.nowUserIndex) !== null && _a !== void 0 ? _a : '';
    _this.corpId = option.corpId;
    _this.corpName = option.corpName;
    _this.englishName = option.englishName;
    _this.loginType = option.loginType;
    _this.uidSource = option.uidSource;
    _this.uin = option.uin;
    _this.userId = option.userId;
    _this.userName = option.userName;
    _this.userPic = option.userPic;
    _this.settings = option.settings;
    _this.bindUserInfo = (_b = option.bindUserInfo) !== null && _b !== void 0 ? _b : {
      type: BIND_TYPE.UNBIND,
      userName: '',
      userPic: '',
      accountType: ACCOUNT_TYPE.UNKNOWN
    };
    _this.vipUserInfo = (_c = option.vipUserInfo) !== null && _c !== void 0 ? _c : {
      type: VipType.NONE,
      vipLevel: VipLevel.NONE,
      beginTime: 0,
      endTime: 0
    };
    _this.key = "".concat(_this.pageType, "-").concat(_this.docId, "-").concat(_this.tinyId);
    return _this;
  }
  return _createClass(UserInfo);
}(Model);
__decorate([primary(), __metadata("design:type", String)], UserInfo.prototype, "key", void 0);
__decorate([index(), __metadata("design:type", String)], UserInfo.prototype, "tinyId", void 0);
__decorate([index(), __metadata("design:type", String)], UserInfo.prototype, "nowUserIndex", void 0);
__decorate([index(), __metadata("design:type", String)], UserInfo.prototype, "docId", void 0);
__decorate([index(), __metadata("design:type", String)], UserInfo.prototype, "pageType", void 0);
__decorate([index(), __metadata("design:type", String)], UserInfo.prototype, "wedriveUin", void 0);
__decorate([index(), __metadata("design:type", String)], UserInfo.prototype, "wedocOpenId", void 0);
__decorate([field(), __metadata("design:type", String)], UserInfo.prototype, "corpId", void 0);
__decorate([field(), __metadata("design:type", String)], UserInfo.prototype, "corpName", void 0);
__decorate([field(), __metadata("design:type", String)], UserInfo.prototype, "englishName", void 0);
__decorate([field(), __metadata("design:type", Number)], UserInfo.prototype, "loginType", void 0);
__decorate([field(), __metadata("design:type", String)], UserInfo.prototype, "openId", void 0);
__decorate([field(), __metadata("design:type", Number)], UserInfo.prototype, "uidSource", void 0);
__decorate([field(), __metadata("design:type", String)], UserInfo.prototype, "uin", void 0);
__decorate([field(), __metadata("design:type", String)], UserInfo.prototype, "userId", void 0);
__decorate([field(), __metadata("design:type", String)], UserInfo.prototype, "userName", void 0);
__decorate([field(), __metadata("design:type", String)], UserInfo.prototype, "userPic", void 0);
__decorate([field(), __metadata("design:type", String)], UserInfo.prototype, "updateTime", void 0);
__decorate([field(), __metadata("design:type", Object)], UserInfo.prototype, "settings", void 0);
__decorate([field(), __metadata("design:type", Object)], UserInfo.prototype, "bindUserInfo", void 0);
__decorate([field(), __metadata("design:type", Object)], UserInfo.prototype, "vipUserInfo", void 0);
UserInfo = __decorate([table(TABLE_NAME.Users), __metadata("design:paramtypes", [Object])], UserInfo);

export { ACCOUNT_TYPE, ALL_LOCAL_FILES_DB_NAME, BIND_TYPE, BaseChangeModel, DB_NAME, DB_NAME_TESTENV, DOCUMENT_DATA_TYPE, DOCUMENT_POLICY, DOCUMENT_RESOURCE_CACHE_STATUS, DOCUMENT_STATUS, DOCUMENT_TYPE, DOCUMENT_TYPE_DESC, DOCUMENT_TYPE_DESC_MAP, DOCUMENT_TYPE_MAP, DRIVE_TYPE, DocumentData, DocumentEntity, DocumentId, DocumentStatus, DriveData, LIST_INFO_TYPE, LIST_TYPE, OfflineData, PadInfo, TABLE_NAME, UserInfo, VipLevel, VipType };
//# sourceMappingURL=index.js.map
